import { useQuery } from "@tanstack/react-query";
import { useRouteMatch } from "react-router-dom";
import { HOChangePersonRequestService } from "../../../../../services/human-organization/change-person-request.service";

export const useGetDetailRequests = () => {
  const { id } = useRouteMatch().params as any;

  const response = useQuery({
    queryKey: ["detail-request-change-person", id],
    queryFn: () => HOChangePersonRequestService.getDetailsChangePersonRequest(id),
    refetchOnMount: "always",
  });

  return response;
};